import { Injectable } from '@angular/core';
import { defaultTranslations, hoelzelTranslations, Translations } from '../../environments/configs/translations';

@Injectable({
    providedIn: 'root'
})
export class TranslationService {

    getTranslation(languageID?: string): Translations {

        // If trans is available use this for translations.
        if (window['trans']) {
            // @ts-ignore
            return window.trans(`bookviewer.${languageID || 'default'}`);
        }

        if (languageID === 'hoelzel') {
            return hoelzelTranslations;
        }

        return defaultTranslations;
    }
}
